module.exports = __webpack_public_path__ + "static/media/Student Login Verification.b1e2f455.png";